import {WMRateScheduleHeaderLookupLayout,  WMCodesLookupLayout,} from '../../../../common/lookups/Layouts/WMLayouts';
import { IDBuyerLookupLayout, IDConsigneeLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import { EDLookupLayout, EDHazardousLayout } from '../../../../common/lookups/Layouts/EDLayouts';
import { ABPopupMessageLayout } from '../../../../common/lookups/Layouts/ABLayouts';
import { CAJobLayout } from '../../../../common/lookups/Layouts/CALayouts';
import { ACDepartmentLayout } from '../../../../common/lookups/Layouts/ACLayouts';
import { FAFundLayout } from '../../../../common/lookups/Layouts/FALayouts';
import { ImItemLookupLayout, IMLocationLookupLayout } from '../../../../common/lookups/Layouts/ImLayouts';
import { WM } from '../../../../const/constants';
import { LocationTypes } from '../../../../enum/Enum';


const classCodes = WMCodesLookupLayout({codeType: '28' });
const subClassCodes = WMCodesLookupLayout({ codeType: '29' });
const receiptCodes = WMCodesLookupLayout({codeType: '30' });
const shipmentCodes = WMCodesLookupLayout({ codeType: '31' });
const edHazardousLayout = EDHazardousLayout();
const eDLookupLayout = EDLookupLayout({ Dataelementnum: '355' ,Versionid: '4010'});
const freightClassCodes = WMCodesLookupLayout({ codeType: '33' });
const holdReasonCodes = WMCodesLookupLayout({ codeType: '02' });
const popupMessageLayout = ABPopupMessageLayout({ tableName: 'IMITEM' });
const imItemLookupLayout = ImItemLookupLayout({ itemType: 'L',moduleName: WM  });
const ratescheduleCodes = WMRateScheduleHeaderLookupLayout({status: 'A', type: "I" });
const locationLookupLayout = IMLocationLookupLayout({ RWarehouse: null,moduleType: WM ,locationType :LocationTypes.StorageLocation})

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "RECORD",
                "tableName": "IMLOT",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "ITEMCODE",
                "tableName": "IMLOT",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "LOTCODE",
                "tableName": "IMLOT",
                "label": "Lot Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "STATUS",
                "tableName": "IMLOT",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "showClearButton": true
            }
        ]
    }
];

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMLOT",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "R_ITEM",
                "tableName": "IMLOT",
                "localizedField": "NONE",
                "label": "Item",
                "type": "lookup",
                "layout": imItemLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "PROFILECODE",
                "tableName": "IMITEM",
                "localizedField": "R_PROFILE",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "CUSTOMERCODE",
                "tableName": "IMITEM",
                "localizedField": "R_IDENTITY",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "LOTCODE",
                "tableName": "IMLOT",
                "label": "Lot",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "DESCRIPTION_1",
                "tableName": "IMLOT",
                "label": "Description - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "DESCRIPTION_2",
                "tableName": "IMLOT",
                "label": "Description - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "STATUS",
                "tableName": "IMLOT",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "CLASSCODE",
                "tableName": "IMLOT",
                "label": "Class",
                "type": "lookup",
                "layout": classCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SUBCLASSCODE",
                "tableName": "IMLOT",
                "label": "Sub Class",
                "type": "lookup",
                "layout": subClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEINTRODUCED",
                "tableName": "IMLOT",
                "label": "Introduced Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEAVAILABLE",
                "tableName": "IMLOT",
                "label": "Available Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEEXPIRATION",
                "tableName": "IMLOT",
                "label": "Expiration Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "R_RATESCHEDULE",
                "tableName": "IMLOT",
                "label": "Rate Schedule",
                "type": "lookup",
                "layout": ratescheduleCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const UOMLayout = [
    {
        "groupId": 1,
        "label": "Inventory Quantity Factor",
        "fields": [
            {
                "name": "INVENTORYUNITNOTUSED",
                "tableName": "IMLOT",
                "label": "Inventory",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "PIECESPERUNITQUANTITY",
                "tableName": "IMLOT",
                "label": "Pieces/Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITSPERPACKAGEQUANTITY",
                "tableName": "IMLOT",
                "label": "Units/Pkg",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PACKAGESPERSHIPPINGUNITQTY",
                "tableName": "IMLOT",
                "label": "Pkg/Ship",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "UOM",
        "fields": [
            {
                "name": "INVENTORYUNITUOM",
                "tableName": "IMLOT",
                "label": "Inventory",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PIECESPERUNITUOM",
                "tableName": "IMLOT",
                "label": "Pieces/Unit",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITSPERPACKAGEUOM",
                "tableName": "IMLOT",
                "label": "Units/Pkg",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PACKAGESPERSHIPPINGUNITUOM",
                "tableName": "IMLOT",
                "label": "Pkg/Ship",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Stoarge Billing",
        "fields": [
            {
                "name": "STORAGEBILLINGSTARTDATE",
                "tableName": "IMLOT",
                "label": "Start",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEBILLINGENDDATE",
                "tableName": "IMLOT",
                "label": "End",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEBILLEDDATE_LAST",
                "tableName": "IMLOT",
                "label": "Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PREVSTORAGEBILLEDDATE_LAST",
                "tableName": "IMLOT",
                "label": "Previous Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "STORAGEBILLEDDATE_NEXT",
                "tableName": "IMLOT",
                "label": "Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PREVSTORAGEBILLEDDATE_NEXT",
                "tableName": "IMLOT",
                "label": "Previous Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "RECURRINGSTORAGE",
                "tableName": "IMLOT",
                "label": "Recurring Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Accounting",
        "fields": [
            {
                "name": "R_GLDEPARTMENT",
                "tableName": "IMLOT",
                "label": "Department",
                "type": "lookup",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_GLFUND",
                "tableName": "IMLOT",
                "label": "GL Fund",
                "type": "lookup",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CAJOBCODE",
                "tableName": "IMLOT",
                "label": "Job",
                "type": "lookup",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Quantity Per Inventory Unit",
        "fields": [
            {
                "name": "UNITVOLUMEQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Volume",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITAREAQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Area",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITVALUEQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Value",
                "type": "number",
                "format": "$ #,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Net Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "GROSSMINUSNET",
                "tableName": "IMLOT",
                "label": "Unit Tare Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "GROSSWEIGHTQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Gross Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "UOM",
        "fields": [
            {
                "name": "UNITVOLUMEUOM",
                "tableName": "IMLOT",
                "label": "Unit Volume",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITAREAUOM",
                "tableName": "IMLOT",
                "label": "Unit Area",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITVALUEUOM",
                "tableName": "IMLOT",
                "label": "Unit Value",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTUOM",
                "tableName": "IMLOT",
                "label": "Unit Net Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTUOM",
                "tableName": "IMLOT",
                "label": "Unit Tare Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            }
            ,
            {
                "name": "GROSSWEIGHTUOM",
                "tableName": "IMLOT",
                "label": "Unit Gross Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "label": "Progressive Billing",
        "fields": [
           {
                "name": "PROGRESSIVECURRENTRATE",
                "tableName": "IMLOT",
                "label": "Current Reate",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "PROGRESSIVELASTRATE",
                "tableName": "IMLOT",
                "label": "Last Reate",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "PROGRESSIVEPREVIOUSLASTRATE",
                "tableName": "IMLOT",
                "label": "Previous Last Reate",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "PROGRESSIVEBILLINGCOUNT",
                "tableName": "IMLOT",
                "label": "# Bills",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            }
        ]
    },
    {
        "groupId": 8,
        "label": "RF Validation",
        "fields": [
            {
                "name": "RFRECEIPTVALIDATION",
                "tableName": "IMLOT",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "RFSHIPMENTVALIDATION",
                "tableName": "IMLOT",
                "label": "Shipment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    },
    {
        "groupId": 9,
        "label": "Other",
        "fields": [
            {
                "name": "POPUPMESSAGE",
                "tableName": "IMLOT",
                "label": "Popup Msg",
                "type": "lookup",
                "layout": popupMessageLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_BUYER",
                "tableName": "IMLOT",
                "label": "Buyer",
                "type": "lookup",
                "layout": IDBuyerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "IMLOT",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }

        ]
    }
]

const StatusLayout = [
    {
        "groupId": 1,
        "label": "Quantity Status",
        "fields": [
            {
                "name": "BeginPeriod",
                "tableName": "IMLOT",
                "label": "Begin Period",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "ON_HAND",
                "tableName": "IMLOT",
                "label": "On Hand",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "IN_RECEIVING",
                "tableName": "IMLOT",
                "label": "In Receiving",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_SHIPPED",
                "tableName": "IMLOT",
                "label": "In Shipping",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_UNAVAILABLE",
                "tableName": "IMLOT",
                "label": "Unavailable",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "AVAILABLE",
                "tableName": "IMLOT",
                "label": "Available",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "IN_ORDERED",
                "tableName": "IMLOT",
                "label": "Pending Rec",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_ORDERED",
                "tableName": "IMLOT",
                "label": "Pending Ship",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "NETAVAILABLE",
                "tableName": "IMLOT",
                "label": "Net Available",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "IN_FUTURE",
                "tableName": "IMLOT",
                "label": "Future Rec",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_FUTURE",
                "tableName": "IMLOT",
                "label": "Future Ship",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Historical Information",
        "fields": [
            {
                "name": "INTRANSACTIONNUMBER",
                "tableName": "IMLOT",
                "label": "First Receipt",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Miscellaneous",
        "fields": [
            {
                "name": "R_LOCATION",
                "tableName": "IMLOT",
                "label": "Location",
                "type": "lookup",
                "layout": locationLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SIZE_1",
                "tableName": "IMLOT",
                "label": "Size - 1",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SIZE_2",
                "tableName": "IMLOT",
                "label": "Size - 2",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]

const CodesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IMLOT",
                "label": "CODE 1",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '18' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IMLOT",
                "label": "CODE 2",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '19' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IMLOT",
                "label": "CODE 3",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '20' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IMLOT",
                "label": "CODE 4",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '21' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IMLOT",
                "label": "CODE 5",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '22' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IMLOT",
                "label": "CODE 6",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '23' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IMLOT",
                "label": "CODE 7",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '24' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IMLOT",
                "label": "CODE 8",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '25' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IMLOT",
                "label": "CODE 9",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IMLOT",
                "label": "CODE 10",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IMLOT",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IMLOT",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IMLOT",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IMLOT",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IMLOT",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IMLOT",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IMLOT",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IMLOT",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IMLOT",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IMLOT",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IMLOT",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IMLOT",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IMLOT",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IMLOT",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IMLOT",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IMLOT",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IMLOT",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IMLOT",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IMLOT",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IMLOT",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMLOT",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMLOT",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMLOT",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMLOT",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMLOT",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IMLOT",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IMLOT",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IMLOT",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IMLOT",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IMLOT",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const LotSublotHeaderLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "TotalQuantity",
                "tableName": "IMLOT",
                "localizedField": "Keysequence",
                "label": "Total Quantity",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "TotalNetWeight",
                "tableName": "IMLOT",
                "localizedField": "Keysequence",
                "label": "Total Net Weight",
                "format": "#,###0.00",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
];
const SublotByConsigneeHeaderLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "SublotRConsignee",
                "tableName": "Imsublot",
                "localizedField": "RConsignee",
                "label": "Consignee ID",
                "type": "lookup",
                "layout": IDConsigneeLookupLayout({ valueExpr: 'id', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "Name",
                "tableName": "Idmaster",
                "label": "Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
]
export {
    SearchLayout,
    PrimaryLayout,
    UOMLayout,
    StatusLayout,
    CodesLayout,
    RefrencesLayout,
    LotSublotHeaderLayout,
    SublotByConsigneeHeaderLayout
}